export enum RulesConstants {
  SET_RULES_ERRORS = 'rules/SET_RULES_ERRORS',
  RESET_RULES_STATE = 'rules/RESET_RULES_STATE',
  RUN_RULE = 'rules/RUN_RULE',
  RUN_ALL_RULES = 'rules/RUN_ALL_RULES',
  SET_IS_SUBMIT_CHART = 'rules/SET_IS_SUBMIT_CHART',
  SET_GROUPED_RULES_ERRORS = 'rules/SET_GROUPED_RULES_ERRORS',
  SET_DISPATCHED_ACTIONS = 'rules/SET_DISPATCHED_ACTIONS',
  SET_IS_LOADING = 'rules/SET_IS_LOADING',
  SAVE_RULE_ERRORS = 'rules/SAVE_RULE_ERRORS',
}
